import { useState } from 'react';
import Text, {
  TEXT_COLOR,
  TEXT_KIND,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_DISPLAY,
} from '@/bit/components/components.text';
import FormTemplate from '@/components/formTemplate/index';
import { SHIPPING_ADDRESS } from '@/constants/shippingAddress';
import CheckboxController from '@/components/checkboxController';
import Address from '@/containers/address';

function ShippingAddress({
  control,
  label,
  title,
  unregister,
  resetField,
  getValues,
  setValue,
}) {
  const [keepAddressCheck, setKeepAddressCheck] = useState(true);
  const handleOnChange = (e) => {
    const { target } = { ...e };
    const { checked } = { ...target };
    if (checked) {
      unregister(SHIPPING_ADDRESS.HORIZONTAL_ADDRESS.ID);
      unregister(SHIPPING_ADDRESS.VERTICAL_ADDRESS.ID);
      unregister(SHIPPING_ADDRESS.PROVINCE.ID);
      unregister(SHIPPING_ADDRESS.ADDRESS.ID);
      unregister(SHIPPING_ADDRESS.ADDRESS_DETAIL.ID);
    }
    setKeepAddressCheck(checked);
  };
  return (
    <div className="shipping-address">
      <FormTemplate titleText={title} cyData={SHIPPING_ADDRESS.ID}>
        <CheckboxController
          inputName={SHIPPING_ADDRESS.KEEP_ADDRESS_CHECK.NAME}
          inputId={SHIPPING_ADDRESS.KEEP_ADDRESS_CHECK.ID}
          control={control}
          rules={SHIPPING_ADDRESS.KEEP_ADDRESS_CHECK.RULES}
          className="checkbox-container"
          defaultValue
          handleOnChange={handleOnChange}
        >
          <Text
            text={`${label}&nbsp;`}
            color={TEXT_COLOR.GREY6}
            kind={TEXT_KIND.SPAN}
            size={TEXT_SIZE.CAPTION2}
            display={TEXT_DISPLAY.INLINE}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
          />
        </CheckboxController>
      </FormTemplate>
      {!keepAddressCheck && (
        <Address
          className="address-container-wrapper"
          unregister={unregister}
          control={control}
          getValues={getValues}
          resetField={resetField}
          formStructure={SHIPPING_ADDRESS}
          componentName={SHIPPING_ADDRESS.ID}
          setInfo={false}
          showTitle={!title}
          setValue={setValue}
        />
      )}
      <style jsx>
        {`
          :global(.checkbox-container) {
            padding-bottom: 12px;
          }
        `}
      </style>
    </div>
  );
}

export default ShippingAddress;
